import { restClient } from '@/Core'
import type { User } from '../Contracts'
import { mapApiUser, type ApiUser } from '../Helpers/apiMappers'

interface UsersResponse {
    items?: ApiUser[]
}

/**
 * Contacts for the chat (new chat modal, names/avatars resolution).
 * Unlike the notification tasks, chat tasks do not mutate stores — they
 * return contract-shaped data and let the calling store own its state
 * (that is how the imported chat-ui stores are written).
 */
export const LoadChatUsersTask = async (): Promise<User[]> => {
    const response = (await restClient.get('/services/users', {
        searchParams: { limit: 300 },
    })) as UsersResponse | null

    return (response?.items ?? []).map(mapApiUser)
}
